<template>
  <router-view></router-view>
</template>

<script>

export default {
  props: {
    name: String,
  },
  metaInfo() {
    return {
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex,nofollow',
        },
      ],
    }
  },

  mounted() {
    if (typeof window !== 'undefined' && !window.timingMeasurement.logged) {
      window.timingMeasurement.appMounted = Date.now()

      window.timingMeasurement.total =
        window.timingMeasurement.appMounted - window.timingMeasurement.domInit

      window.timingMeasurement.appMounted =
        window.timingMeasurement.appMounted -
        window.timingMeasurement.routerReady

      window.timingMeasurement.routerReady =
        window.timingMeasurement.routerReady - window.timingMeasurement.jsInit

      window.timingMeasurement.jsInit =
        window.timingMeasurement.jsInit - window.timingMeasurement.domInit

      window.timingMeasurement.domInit = 0
      window.timingMeasurement.logged = true
    }
  },
  componentIdentifier: 'transparentIndexComponent',
}
</script>

<style lang="sass" scoped>
  $red: #f00
  body
    text-align: center
    color: $red
</style>
